import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#button" }),
    /*#__PURE__*/_createTextVNode(" Button ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Commonly used button. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabledButton = _resolveComponent("EUIDisabledButton")
  const _component_EUITextButton = _resolveComponent("EUITextButton")
  const _component_EUIIconButton = _resolveComponent("EUIIconButton")
  const _component_EUIButtonGroup = _resolveComponent("EUIButtonGroup")
  const _component_EUILoadingButton = _resolveComponent("EUILoadingButton")
  const _component_EUISizes = _resolveComponent("EUISizes")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabledButton),
    _createVNode(_component_EUITextButton),
    _createVNode(_component_EUIIconButton),
    _createVNode(_component_EUIButtonGroup),
    _createVNode(_component_EUILoadingButton),
    _createVNode(_component_EUISizes)
  ], 64))
}